import styled from "styled-components";
import { buttonTypography } from "../../../../../components/typography/MuiTypography.style";
import { COLORS, responsive } from "../../../../../styles/constants.style";

export const ParticipantsSearchFormWrapper = styled.div`
  background-color: ${COLORS.cirrus_white};
  padding: 24px 0px 24px 16px;

  ${responsive.MOBILE`
    padding: 16px 0 16px 8px;
  `}

  .MuiGrid2-root {
    padding-right: 16px;

    ${responsive.MOBILE`
      padding-right: 8px;
    `}
  }

  .MuiGrid2-container {
    padding: 0px;
    margin-top: 0;
  }
  .MuiPickersTextField-root,
  .MuiPickersInputBase-root {
    width: 100%;
  }

  .mui-label {
    color: ${COLORS.cirrus_black10};
    line-height: 20px;
    margin-bottom: 8px;
  }

  .expand-btn-container {
    width: 100%;
    margin-top: 32px;
    padding: 8px 16px;
    cursor: pointer;
    text-align: center;
    position: relative;

    &::before,
    &::after {
      content: "";
      position: absolute;
      top: 50%;
      border-top: 1px dotted ${COLORS.primary_light_blue5}; /* Dotted border on left and right */
      width: 40%;
    }

    &::before {
      left: 0;
      transform: translateY(-50%);
    }

    &::after {
      right: 16px;
      transform: translateY(-50%);
    }

    .MuiIconButton-root {
      height: 28px;
      width: 28px;
      padding: 0;
    }
    .expand-text {
      ${buttonTypography}
      line-height: 19.8px;
      text-align: center;
      color: ${COLORS.primary_light_blue};
      margin-right: 8px;
      cursor: pointer;
      height: 28px;
      display: inline-flex;
      vertical-align: middle;
      align-items: center;
    }
  }

  .button-container {
    justify-content: end;
    margin-top: 32px;

    ${responsive.MOBILE`
      flex-direction: column-reverse;
      margin-top: 16px;
      margin-right: 8px;
    `}

    button {
      ${responsive.MOBILE`
        width: 100%;
        margin: 0;
      `}
    }
  }
`;
